import clsx, { ClassValue } from 'clsx'
import { PropsWithChildren } from 'react'

export type BadgeProps = PropsWithChildren<{
  color?: 'primary' | 'secondary' | 'neutral' | 'success' | 'error' | 'warning' | 'info'
  outline?: boolean
  soft?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: ClassValue
}>

export function Badge (props: BadgeProps) {
  const { color, outline, soft, size, className, children } = props

  return (
    <span
      className={clsx(
        'badge',
        soft && 'badge-soft',
        outline && 'badge-outline',
        color === 'primary' && 'badge-primary',
        color === 'secondary' && 'badge-secondary',
        color === 'neutral' && 'badge-neutral',
        color === 'success' && 'badge-success',
        color === 'error' && 'badge-error',
        color === 'warning' && 'badge-warning',
        color === 'info' && 'badge-info',
        size === 'xs' && 'badge-xs',
        size === 'sm' && 'badge-sm',
        size === 'md' && 'badge-md',
        size === 'lg' && 'badge-lg',
        'shadow-none',
        className
      )}
    >
      {children}
    </span>
  )
}
